<template>
    <section class="susa-list-container">
        <template v-if="cItems">
            <h5>{{ title }}</h5>
            <Table
                v-if="items"
                bordered
                striped
                small
                showFilter
                tableClass="susa-list"
                :responsive="true"
                :fields="cFields"
                :items="cItems"
                :isBusy="busy"
                :sortBy="sortBy"
                :sortDesc="sortDesc"
                busyText="Lädt SuSa-Daten..."
                emptyText="Keine SuSa-Daten gefunden"
                @sortChanged="sortChanged"
            >
                <template v-slot:income="{ row: row }">
                    <template v-if="row.value && row.value != 0">
                        <span class="text-success">
                            {{ currency(row.value) }}
                        </span>
                    </template>
                    <template v-else>
                        <span class="text-muted">
                            {{ currency(row.value) }}
                        </span>
                    </template>
                </template>

                <template v-slot:outcome="{ row: row }">
                    <template v-if="row.value && row.value != 0">
                        <span class="text-danger">
                            {{ currency(row.value) }}
                        </span>
                    </template>
                    <template v-else>
                        <span class="text-muted">
                            {{ currency(row.value) }}
                        </span>
                    </template>
                </template>

                <template v-slot:sum_all_years="{ row: row }">
                    <template v-if="row.value && row.value != 0">
                        <span
                            v-html="currencyColored(row.value)"
                        >
                        </span>
                    </template>
                    <template v-else>
                        <span class="text-muted">
                            {{ currency(row.value) }}
                        </span>
                    </template>
                </template>

                <template v-slot:total="{ row: row }">
                    <template v-if="row.value && row.value != 0">
                        <div v-html="currencyColored(row.value)"></div>
                    </template>
                    <template v-else>
                        <span class="text-muted">
                          {{ currency(row.value) }}
                        </span>
                    </template>
                </template>

              <template v-slot:endsum="{ row: row }">
                <template v-if="row.value && row.value != 0">
                  <div v-html="currencyColored(row.value)"></div>
                </template>
                <template v-else>
                        <span class="text-muted">
                          {{ currency(row.value) }}
                        </span>
                </template>
              </template>

                <template v-slot:custom-foot="{ data }">
                    <b-tr>
                        <b-td
                            colspan="3"
                        >
                            Zwischensummen {{ title }}
                        </b-td>
                        <b-td
                            v-if="fields.includes('in_out')"
                            class="text-right"
                            v-html="
                                currencyColored(
                                    data.items.reduce((p, v) => {
                                        return p + parseFloat(v.income);
                                    }, 0)
                                )
                            "
                        >
                        </b-td>
                        <b-td
                            v-if="fields.includes('in_out')"
                            class="text-right"
                            v-html="
                                currencyColored(
                                    data.items.reduce((p, v) => {
                                        return p + parseFloat(v.outcome);
                                    }, 0)
                                )
                            "
                        >
                        </b-td>
                        <b-td
                            class="text-right"
                            v-html="
                                currencyColored(
                                    data.items.reduce((p, v) => {
                                        return p + parseFloat(v.total);
                                    }, 0)
                                )
                            "
                        >
                        </b-td>
                        <b-td
                            v-if="fields.includes('sum_all_years')"
                            class="text-right"
                            v-html="
                                currencyColored(
                                    data.items.reduce((p, v) => {
                                        return p + parseFloat(v.sum_all_years);
                                    }, 0)
                                )
                            "
                        >
                        </b-td>
                        <b-td
                            v-if="fields.includes('endsum')"
                            class="text-right"
                            v-html="
                                  currencyColored(
                                      data.items.reduce((p, v) => {
                                          return p + parseFloat(v.endsum);
                                      }, 0)
                                  )
                              "
                        >
                        </b-td>
                    </b-tr>
                </template>
            </Table>
        </template>
    </section>
</template>

<script>
import Size from "@/mixins/Size/Size";
import Currency from "@/mixins/Currency/Currency";
import Table from "@/components/Table/Table";

export default {
    name: "FiBuSuSaList",
    mixins: [Size, Currency],
    components: {
        Table
    },
    props: ["title", "busy", "fields", "items"],
    data() {
        return {
            defaultFields: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true,
                    class: "text-center"
                },
                {
                    key: "kontonr",
                    label: "K-Nr.",
                    sortable: true
                },
                {
                    key: "text",
                    label: "Bezeichnung",
                    sortable: true
                },
                {
                    key: "income",
                    label: "Einnahmen",
                    sortable: true,
                    class: "text-right"
                },
                {
                    key: "outcome",
                    label: "Ausgaben",
                    sortable: true,
                    class: "text-right"
                },
                {
                    key: "total",
                    label: "Saldo",
                    sortable: true,
                    class: "text-right"
                },
                {
                  key: "endsum",
                  label: "Jahresendsummen",
                  sortable: true,
                  class: "text-right"
                },
                {
                    key: "sum_all_years",
                    label: "Summe alle Jahre",
                    sortable: true,
                    class: "text-right"
                }
            ],
            lSortBy: "kontonr",
            sortDesc: false
        };
    },
    computed: {
        sortBy() {
            return this.lSortBy;
        },
        cFields() {
            let pFields = [...this.defaultFields];

            if (!this.fields.includes("sum_all_years")) {
                pFields = pFields.filter(f => f.key !== "sum_all_years");
            }

            if (!this.fields.includes("in_out")) {
                pFields = pFields.filter(
                    f => f.key !== "income" && f.key !== "outcome"
                );
            }

            if (!this.fields.includes("endsum")) {
                pFields = pFields.filter(f => f.key !== "endsum");
            }

            return pFields;
        },
        cItems() {
            return this.items.map(item => {
                return {
                    id: item.id,
                    kontonr: item.kontonr,
                    text: item.text,
                    income: item.sums.income,
                    outcome: item.sums.outcome,
                    total: item.sums.total,
                    endsum: item.sums.endsum,
                    sum_all_years: item.sum_all_years
                };
            });
        }
    },
    methods: {
        sortChanged(ctx) {
            this.lSortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
        }
    }
};
</script>
